<section id="orderDocuments" class="builder-program-file-upload" aria-labelledby="builder-program-file-upload-title">
  <h2 id="builder-program-file-upload-title">{{ 'checkoutAddress.builderProgramFileUpload.title' | cxTranslate }}<span
      aria-hidden="true">*</span></h2>
  <p>{{ 'checkoutAddress.builderProgramFileUpload.instructions' | cxTranslate }}</p>

  <label class="drop-zone" [class.dragging]="isDragging" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <input type="file" accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" multiple
      [disabled]="isUploading || uploadedDocuments.length === maxDocuments" (change)="onFileInputChange($event)" />
    <img src="../../../../../assets/icons/upload_document_black_68.svg" alt="" aria-hidden="true" />
    <span>{{ 'checkoutAddress.builderProgramFileUpload.dropZonePrefix' | cxTranslate }} <u>{{
        'checkoutAddress.builderProgramFileUpload.browseFiles' | cxTranslate }}</u></span>
  </label>

  <div class="upload-error" aria-live="polite" [class.visible]="documentErrorService.error$ | async">
    {{ documentErrorService.error$ | async }}
  </div>

  <div class="upload-progress" *ngIf="isUploading" role="status" aria-live="polite">
    <div class="upload-progress-track" role="progressbar" aria-label="Uploading documents"
      [attr.aria-valuenow]="uploadProgress ?? 0" aria-valuemin="0" aria-valuemax="100">
      <div class="upload-progress-fill" [style.width.%]="uploadProgress ?? 0"></div>
    </div>
    <span class="upload-progress-value">{{ uploadProgress ?? 0 }}%</span>
  </div>

  <ul class="uploaded-documents" *ngIf="uploadedDocuments.length"
    [attr.aria-label]="'checkoutAddress.builderProgramFileUpload.uploadedDocumentsLabel' | cxTranslate">
    <li *ngFor="let document of uploadedDocuments">
      <img src="assets/icons/file_icon_black.svg" alt="" aria-hidden="true" />
      <span class="document-details">
        <strong>{{ document.fileName }}</strong>
        <span *ngIf="document.size !== undefined">{{ formatFileSize(document.size) }}</span>
      </span>
      <button type="button" [disabled]="isUploading || removingDocumentCode === document.code"
        [attr.aria-label]="'checkoutAddress.builderProgramFileUpload.removeDocument' | cxTranslate: { documentName: document.fileName }"
        (click)="removeDocument(document)">
        <cx-spinner *ngIf="removingDocumentCode === document.code"></cx-spinner>
        <img *ngIf="removingDocumentCode !== document.code" src="assets/icons/close_black_24.svg" alt="" />
      </button>
    </li>
  </ul>
</section>
